/**
 * Xoá bộ nhớ đệm của trò chơi trên trình duyệt này: gỡ service worker, xoá Cache Storage,
 * IndexedDB, sessionStorage rồi tải lại trang với tham số chống cache.
 * resetSettings = true: xoá luôn cài đặt (dn.*), chỉ giữ nhân vật đang chọn & máy chủ.
 * Không xoá phiên đăng nhập.
 */
const KEEP = new Set(['dn.character', 'dn.server']);

export async function clearAppCache(resetSettings = false): Promise<void> {
  try {
    if ('serviceWorker' in navigator) for (const r of await navigator.serviceWorker.getRegistrations()) await r.unregister();
  } catch { /* bỏ qua */ }
  try { if ('caches' in window) for (const k of await caches.keys()) await caches.delete(k); } catch { /* bỏ qua */ }
  try {
    const dbs = (indexedDB as IDBFactory & { databases?: () => Promise<Array<{ name?: string }>> }).databases;
    if (dbs) for (const d of await dbs.call(indexedDB)) if (d.name) indexedDB.deleteDatabase(d.name);
  } catch { /* bỏ qua */ }
  try { sessionStorage.clear(); } catch { /* bỏ qua */ }
  if (resetSettings) {
    try { for (const k of Object.keys(localStorage)) if (k.startsWith('dn.') && !KEEP.has(k)) localStorage.removeItem(k); } catch { /* bỏ qua */ }
  }
  const u = new URL(location.href); u.searchParams.set('v', String(Date.now()));
  location.replace(u.toString());
}
